import { render, staticRenderFns } from "./BatchSourceConfig.vue?vue&type=template&id=a8f3e932"
import script from "./BatchSourceConfig.vue?vue&type=script&lang=js"
export * from "./BatchSourceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports